import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { stageDeployApiRef } from './api/StageDeployApi';
import { StageDeployClient } from './api/StageDeployClient';

export const stageDeployPlugin = createPlugin({
  id: 'stage-deploy',
  apis: [
    createApiFactory({
      api: stageDeployApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new StageDeployClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const StageDeployPage = stageDeployPlugin.provide(
  createRoutableExtension({
    name: 'StageDeployPage',
    component: () =>
      import('./components/StageDeployPage/StageDeployPage').then(
        m => m.StageDeployPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
